import { AnyAction, isAnyOf, ListenerMiddlewareInstance, ThunkDispatch } from '@reduxjs/toolkit'
import { claimRecordsApi } from '@redux/queries/claimRecords'
import { connectorSlice } from '@redux/slices/connectorSlice'
import { clearLocalFormState } from '@utils/localFormState'

type ListenerInstance = ListenerMiddlewareInstance<unknown, ThunkDispatch<unknown, unknown, AnyAction>, unknown>

/**
 * Cleanup local form state, e.g. when claim record deleted
 */
export const initLocalFormStateListener = (listenerMiddleware: ListenerInstance) => {
  // claim record deleted
  listenerMiddleware.startListening({
    matcher: isAnyOf(
      claimRecordsApi.endpoints.deleteClaimRecord.matchFulfilled,
      connectorSlice.actions.sessionExpired,
      connectorSlice.actions.connectorLogoutInProgress,
      connectorSlice.actions.connectorOrderComplete
    ),

    effect: () => {
      clearLocalFormState()
    },
  })
}
